import table from './css/table';
import button from './css/button';
import form from './css/form';
import tabs from './css/tabs';
import modal from './css/modal';
import submenu from './css/submenu';
import layout from './css/layout';
import contextmenu from './css/contextmenu';

const css = {
    table,
    button,
    form,
    tabs,
    modal,
    submenu,
    contextmenu,
    layout
};

export default css;